<template>
  <div class="shortcut-container" @click.self="closeModal">
    <div class="shortcut-main">
      <div class="close" @click="closeModal">&times;</div>
      <div class="shortcut-title iconfont">&#xe68b; 快捷方式</div>
      <div class="shortcut-items">
        <div class="shortcut-title">通用环境</div>
        <div class="shortcut-list">
          <div class="shortcut-item">
            <span class="iconfont">&#xe637; 退出当前</span>
            <span>ESC</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe633; 返回主页</span>
            <span>Ctrl + B</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe632; 开始任务</span>
            <span>Ctrl + Enter</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe6de; 粘贴文本</span>
            <span>Ctrl + Shift + V</span>
          </div>
        </div>
        <div class="shortcut-list">
          <div class="shortcut-item">
            <span class="iconfont">&#xe640; 粘贴图像</span>
            <span>Ctrl + V</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe944; 打开/关闭评论</span>
            <span>Shift + D</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe855; 图库中心</span>
            <span>Shift + P</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe68b; 快捷查看</span>
            <span>Shift + S</span>
          </div>
        </div>
        <div class="shortcut-title">模块环境</div>
        <div class="shortcut-list">
          <div class="shortcut-item">
            <span class="iconfont">&#xe68d; 一键抠图</span>
            <span>Ctrl + 1</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe765; 一键裁切</span>
            <span>Ctrl + 2</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe694; 无界扩图</span>
            <span>Ctrl + 3</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe68e; 万物迁移</span>
            <span>Ctrl + 4</span>
          </div>
        </div>
        <div class="shortcut-list">
          <div class="shortcut-item">
            <span class="iconfont">&#xe691; 智能修复</span>
            <span>Ctrl + 5</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe8ac; Kontext_V2编辑</span>
            <span>Ctrl + 6</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe695; PS图像编辑</span>
            <span>Ctrl + 7</span>
          </div>
          <div class="shortcut-item">
            <span class="iconfont">&#xe68f; 替换甲片</span>
            <span>Ctrl + 0</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShortCut',
  data() {
    return {}
  },
  props: {
    keyBoardVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    keyBoardVisible: function (newVal) {
      const main = document.querySelector('.shortcut-container')
      if (newVal) {
        main.style.right = '0%'
        main.style.transition = 'all 0.5s'
      } else {
        main.style.right = '100%'
        main.style.transition = 'all 0.5s'
      }
    }
  },
  methods: {
    // 退出
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeModal()
      }
    },
    closeModal() {
      this.$emit('update:keyBoardVisible', false)
      const main = document.querySelector('.shortcut-container')
      main.style.right = '100%'
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc)
    const main = document.querySelector('.shortcut-container')
    main.style.right = '100%'
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 23px
}

.shortcut-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  /* 遮罩层颜色 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  transition: all 0.5s;

  .shortcut-main {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;
    transition: all 0.5s;
    justify-content: center;
    align-items: center;

    .close {
      top: 20px;
      right: 20px;
      position: absolute;
      width: 50px;
      height: 50px;
      font-size: 40px;
      color: white;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        transform: scale(1.05);
      }
    }

    .shortcut-title {
      width: 2048px;
      padding: 10px;
      font-size: 30px;
      text-align: left;
      color: @font_white;
      transition: all 0.5s;
    }

    .shortcut-items {
      padding: 10px 20px 20px 20px;
      width: 2048px;
      height: 1024px;
      border-radius: @border_radius;
      justify-content: flex-start;
      align-items: flex-start;
      background-color: rgba(0, 0, 0, 0.4);

      .shortcut-list {
        margin-top: 10px;
        display: flex;
        gap: 10px;

        .shortcut-item {
          display: flex;
          padding: 40px;
          justify-content: space-between;
          align-items: center;
          gap: 0px 50px;
          width: 494px;
          height: 100px;
          border: 2px dashed rgba(255, 255, 255, 0.5);
          border-radius: @border_radius;
          color: @font_white;
          transition: all 0.5s;

          &:hover {
            transition: all 0.5s;
            transform: scale(1.02);
          }

          span:nth-child(1),
          span:nth-child(2) {
            font-size: 30px;
          }
        }
      }
    }
  }
}
</style>
